import { render, staticRenderFns } from "./WashAndCare.vue?vue&type=template&id=2855c962&"
import script from "./WashAndCare.vue?vue&type=script&lang=js&"
export * from "./WashAndCare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports